import { Controller } from '@hotwired/stimulus'
// @ts-expect-error: @hotwired/turbo is not typed
import * as Turbo from '@hotwired/turbo'
// @ts-expect-error: el-transition is not typed
import { enter, leave } from 'el-transition'

import { membersCards } from 'rails_routes'

// Connects to data-controller="order-physical-card-dialog"
export default class extends Controller<HTMLDialogElement> {
  static targets = [
    'body',
    'close',
  ]

  declare readonly bodyTarget: HTMLElement
  declare readonly closeTarget: HTMLElement

  connect (): void {
    enter(this.closeTarget)
    enter(this.bodyTarget)
    this.element.showModal()

    document.body.classList.add('modal-open') // Locks scrolling
    document.documentElement.addEventListener('turbo:submit-end', this.handleResponse)
  }

  // I shouldn't have to do this, but, Turbo is _not_ redirecting as the docs say it will
  // upon a successful response from a form submission:
  //
  // https://turbo.hotwired.dev/handbook/drive#redirecting-after-a-form-submission
  //
  // This workaround should probably be revisited later as maybe there's something I'm missing.
  // Or maybe there's currently a bug in Turbo. I've read multiple recent threads about this in
  // the Hotwire community forums. However, this works and I've already spent too much time
  // trying to debug so I don't have to do this and it's just time to move on.
  handleResponse = (e: Event): void => {
    if ((e as CustomEvent).detail.success) {
      window.location.href = membersCards.index()
    }
  }

  close (): void {
    Promise.all([leave(this.closeTarget), leave(this.bodyTarget)]).then(() => {
      document.body.classList.remove('modal-open') // Unlocks scrolling
      Turbo.visit(membersCards.index(), { frame: 'modal' })
    })
  }
}
